import { roundNumberAndDecimals } from '@teinor/erp/prices'
import { totalCalculateParams } from '@teinor/erp/prices/quote/calculate'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import { stringMatchWithSearch } from '../../../../../../utils/globals/search'
import { OrderLayoutTableFilter } from '../../../../../inputTableLayouts/order/OrderLayout/OrderTable/useOrderLayoutTableLogic/types'
import { ProductEscandallingTDTy } from './types'

export const parseDataToProductEscandallingTD = (data: TwinDictionary[] ) => {
    const result: ProductEscandallingTDTy = {
        tableData: [], selectedProducts: {}, dictPosTableData: {}, filters: { generalSearchbar: '', order: {}, singleFieldsSearch: {} }, selectedIds: []
    }
    if (data){
        let order = 1
        for (const key in data) {
            const parsedKey = parseInt(key)
            const productEscandalling = data[key]
            result.dictPosTableData[productEscandalling.id] = parsedKey
            const copyProductEscandalling = JSON.parse(JSON.stringify({ ...productEscandalling, order, absoluteIndex: parsedKey }))
            result.tableData.push(copyProductEscandalling)
            result.selectedIds.push(productEscandalling.id)
            order++
        }
    }
    result.tableData.push({ type: 'addButton', id: 'addButton' })

    return result
}

export const parseBeforeSubmit = (products: TwinDictionary[], id: number) => {
    let totalCost = 0
    let totalCostMargin = 0
    const productsEscandalling: TwinDictionary[] = []
    const copyProducts = JSON.parse(JSON.stringify(products))
    copyProducts.pop()
    for (const product of copyProducts) {
        if(product.cost !== null){
            if (!product.ProductEscandallingId){
                productsEscandalling.push({...product, ProductId: id, ProductEscandallingId: product.ProductId})
            }else {
                productsEscandalling.push(product)
            }
            if (product.rowPriceCost) {
                totalCost += parseFloat(product.rowPriceCost)
            }
            if (product.rowPriceCostWithMargin) {
                totalCostMargin += parseFloat(product.rowPriceCostWithMargin)
            }
        }
    }
    totalCost = roundNumberAndDecimals(totalCost, totalCalculateParams)
    totalCostMargin = roundNumberAndDecimals(totalCostMargin, totalCalculateParams)
    const marginCalculated = roundNumberAndDecimals(((totalCostMargin * 100) / totalCost) - 100, totalCalculateParams)
    return { productsEscandalling, marginCalculated, totalCost, totalCostMargin, ProductId: id } 
}

export const filterTableDataProductEscandalling = (data: ProductEscandallingTDTy) => {
    const newResult: { dictPosTable: TwinDictionary, tableData: TwinDictionary[] } = {
        dictPosTable: {},
        tableData: []
    }
    if (data.filteredTableData) {
        for (let index = 0; index < data.filteredTableData.length; index++) {
            const product = data.filteredTableData[index] as any
            const pos = data.dictPosTableData[product.id]
            const element = data.tableData?.[pos]
            element.absoluteIndex = index
            newResult.dictPosTable[element.id] = index
            newResult.tableData.push(element)
        }
        return newResult
    }
    for (let index = 0 ; index < data.tableData.length; index++) {
        const element = data.tableData[index]
        element.absoluteIndex = index
        newResult.dictPosTable[element.id] = index
        newResult.tableData.push(element)
    }
    return newResult
}

const futureFieldsToCheck: TwinDictionary = {
    generalSearchbar: { fields: ['reference', 'code_bar', 'name'] },
}

export const filterCompleteDataByFiltersPE = (tableData: { [fieldName: string]: any }[], filters: OrderLayoutTableFilter) => {
    const result: { [fieldName: string]: any }[] = []
    let dictTableData: TwinDictionary = {}
    let absoluteIndex = 0
    for (const product of tableData) {
        product.absoluteIndex = absoluteIndex
        absoluteIndex++
        if (!product.id) {
            continue
        }
        dictTableData[product.id] = product
        const toSearch: [string, string][] = []
        if (filters.generalSearchbar !== '') {
            toSearch.push(['generalSearchbar', filters.generalSearchbar])
        }
        let mustAdd = true
        for (const toSearchItem of toSearch) {
            const [key, value] = toSearchItem
            const myField = futureFieldsToCheck[key]
            const myFields = myField.fields
            let foundField = false
            for (const field of myFields) {
                if (stringMatchWithSearch(value, product[field])) {
                    foundField = true
                    break
                }
            }
            if (!foundField) {
                mustAdd = false
            }
        }
        if (mustAdd) {
            result.push({id: product.id})
        }
    }
    return result
}